export default function ResultsSection({ t }) {
  if (!t.results) return null;
  const { suptitle, title, subtitle, stats } = t.results;
  return (
    <section id="results" className="py-20 bg-white border-y border-gray-100" data-testid="results-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          {suptitle && (
            <span className="inline-block text-xs font-bold tracking-[0.2em] text-[#CDA34F] uppercase mb-4">{suptitle}</span>
          )}
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">{title}</h2>
          <p className="text-base text-gray-500 max-w-xl mx-auto">{subtitle}</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6 rounded-2xl bg-gray-50 border border-gray-100">
              <div className="text-3xl sm:text-4xl font-extrabold text-[#CC0000] mb-2 tracking-tight">{stat.value}</div>
              <div className="text-sm text-gray-600 font-medium leading-snug">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
